module.exports = __webpack_public_path__ + "static/media/South_Burnett.35e11215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/South_Burnett.jpg
// module id = 660
// module chunks = 0